import { render, staticRenderFns } from "./premi.vue?vue&type=template&id=2dc0d41c&"
import script from "./premi.vue?vue&type=script&lang=ts&"
export * from "./premi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports